export const update = {
  form: {
    tankNo: '洗剤No',
    detergentName: '洗剤名',
    method: '洗剤投入方法',
    netWeightMl: '1ケース内容量/ml',
    thresholdQuantity: 'アラート内容量/ml',
    remainingQuantity: '残量/ml',
    manual: '手動',
    automatic: '自動',
    requireTankNo: '洗剤Noを入力してください',
    requireDetergentName: '洗剤名を入力してください',
    requireMethod: '洗剤投入方法を入力してください',
    requireRemainingQuantity: '残量/mlを入力してください',
    requireThresholdQuantity: 'アラート内容量/mlを入力してください',
    requireNetWeightMl: '内容量（ml）を入力してください',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
    cancel: 'キャンセル',
    update: '保存',
  },
  pageHeader: {
    title: '洗剤タンクリスト　洗剤タンク情報編集画面',
    back: '戻る',
  },
}
